/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_LeadInputs */

const en_mk_agent_lead = /** @type {(inputs: Mk_Agent_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The difference between an assistant and a colleague is accountability. Here an agent takes a task on someone’s behalf, is judged by that person’s permissions, and leaves a record of every step.`)
};

const id_mk_agent_lead = /** @type {(inputs: Mk_Agent_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beda antara asisten dan rekan kerja adalah tanggung jawab. Di sini agen menerima tugas atas nama seseorang, izinnya dinilai dari orang itu, dan setiap langkahnya tercatat.`)
};

/**
* | output |
* | --- |
* | "The difference between an assistant and a colleague is accountability. Here an agent takes a task on someone’s behalf, is judged by that person’s permissions..." |
*
* @param {Mk_Agent_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_lead = /** @type {((inputs?: Mk_Agent_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_lead(inputs)
	return en_mk_agent_lead(inputs)
});